type Translations = {
  [key: string]: string;
};

export interface PreloadedDataInterface {
  apply_url: string;
  api_namespace: string;
  translations: Translations;
}

export default function preload(): PreloadedDataInterface {
  const preloadDataElement = document.getElementById('react-shp-search-preload');

  if (!preloadDataElement) {
    throw new Error('No preload data provided.');
  }

  return JSON.parse(preloadDataElement.innerText.trim());
}
